<template>
  <div
    v-if="show"
    class="cropper-overlay"
  >
    <div
      class="wrapper"
    >
      <div class="inner">
        <!-- These two menus do the same - The only change is the position of the menu -->
        <!-- Left menu -->
        <base-context-menu
          v-if="!menuOnBottom"
          ref="contextMenu"
          :items="menuOptions"
          :close-on-click="false"
          always-open
          @open="onContextMenuOpen"
        />
        <cropper
          v-if="show"
          :key="`cropper_${key}`"
          ref="cropper"
          v-hammer:tap="onTap"
          class="cropper"
          :src="imageSrc"
          :move-image="false"
          :stencil-component="toKebabCase(stencilComponent.name)"
          :stencil-props="stencilProps"
          :default-size="defaultSize"
          :default-position="defaultPosition"
          :default-visible-area="defaultVisibleArea"
          :round-result="false"
          :auto-zoom="false"
          :resize-image="false"
          image-restriction="stencil"
          priority="visible-area"
          @ready="onCropperReady"
          @change="onCropperChange"
          @error="onCropperError"
        />
        <!-- :style="`height: ${containerSize.h}px; width: ${containerSize.w}px;`" -->
        <!-- Bottom menu -->
        <div
          v-if="menuOnBottom"
          class="cropper__bottom-menu image-box-tools"
        >
          <template v-for="(option, index) in menuOptions">
            <template v-if="option.key === 'divider'">
              <div
                :key="index"
                class="mx-auto"
              >
                <!-- This is just a line -->
                <span style="width: 1px; height: 24px; display: inline-block; background: #D4D4D4" />
              </div>
            </template>
            <template v-else-if="option.items">
              <image-box-tool-with-options
                :key="index"
                :title="option.label"
                :icon="option.icon"
              >
                <div class="image-box__option">
                  <template v-for="shape in option.items">
                    <base-icon
                      :key="shape.icon"
                      :icon="shape.icon"
                      :class="`${shape.class} ${isIPad ? 'ipad' : ''}`"
                      class="mr-2"
                      @click="shape.action()"
                    />
                  </template>
                </div>
              </image-box-tool-with-options>
            </template>
            <template v-else>
              <span
                :key="index"
                class="image-box-tool d-inline-block"
              >
                <button
                  type="button"
                  class="image-row__button"
                  @click="option.action()"
                >
                  <div class="d-flex align-items-center">
                    <base-icon
                      v-if="option.icon"
                      :icon="option.icon"
                      class="mr-2"
                    />
                    <div>{{ option.label }}</div>
                  </div>
                </button>
              </span>
            </template>
          </template>

          <!-- <base-button @click="menuOptions[3].action()">
            Apply!
          </base-button> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Cropper, RectangleStencil } from 'vue-advanced-cropper';
import { elements } from '@/components/Base/BaseContextMenu';
import * as stencils from './FrameCropper/index';
import 'vue-advanced-cropper/dist/style.css';

export default {
  inject: ['parent'],
  name: 'FrameCropper',
  components: { Cropper },
  props: {
    menuOnBottom: {
      type: Boolean,
      default: false,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      imageSrc: null,
      stencilProps: {
        movable: true,
        scalable: false,
        resizable: true,
      },
      image: null,
      standardFrame: {
        icon: 'crop',
        component: RectangleStencil,
      },
      frames: [{
        icon: 'shape-square',
        name: 'Rectangle',
        component: stencils.SlSquareStencil,
        initialRatio: 1 / 1,
      }, {
        icon: 'shape-circle',
        name: 'Circle',
        component: stencils.SlCircleStencil,
        initialRatio: 1 / 1,
      }, {
        icon: 'shape-oval',
        name: 'Oval',
        component: stencils.OvalStencil,
        initialRatio: 9 / 16,
      }, {
        icon: 'shape-closed-arc',
        name: 'Closed Arc',
        component: stencils.ClosedArchStencil,
        initialRatio: 9 / 16,
      }, {
        icon: 'shape-hexagon',
        name: 'Hexagon',
        component: stencils.HexagonStencil,
      }, {
        icon: 'shape-star',
        name: 'Star',
        component: stencils.StarStencil,
      }, {
        icon: 'shape-heart',
        name: 'Heart',
        component: stencils.HeartStencil,
      }],
      selectedFrameClass: RectangleStencil,

      contextMenuWidth: 0,

      autoCenter: true,
      actionPerformed: false, // To show outlined selected menu item
      key: Date.now(),
    };
  },
  computed: {
    parent_zoom() {
      return this.parent.canvas.getZoom();
    },
    isIPad() {
      // For now, this is equivalent to menuOnBottom prop
      return this.menuOnBottom;
    },
    menuOptions() {
      const buttonClass = this.menuOnBottom ? '' : 'shape-button';

      return [{
        label: 'Standard',
        icon: 'crop',
        // eslint-disable-next-line
        action: () => {this.actionPerformed = true; this.selectedFrameClass = RectangleStencil},
        // class: this.actionPerformed && this.selectedFrameClass.name === RectangleStencil.name ? 'menu-item--outlined' : '',
      }, {
        // Submenu
        label: 'More Shapes',
        icon: this.frames.find((frame) => frame.component.name === this.stencilComponent.name)?.icon ?? 'shape-square',
        iconSmall: true,
        // Classes for the item button, NOT for it's child submenu container
        class: 'shape-submenu', // ${this.actionPerformed && this.frames.map((f) => f.component.name).includes(this.selectedFrameClass.name) ? 'menu-item--outlined' : ''}`,
        items: this.frames.map((f) => ({
          icon: f.icon,
          class: `${buttonClass} ${this.selectedFrameClass.name === f.component.name ? `${buttonClass}--selected` : ''}`,
          label: '',
          // eslint-disable-next-line
          action: () => { this.actionPerformed = true; this.selectedFrameClass = f.component},
        })),
      }, elements.divider, {
        label: 'Apply',
        icon: 'check',
        action: this.doCrop,
      }, {
        label: 'Reset Crop',
        icon: 'redo',
        action: this.restoreOriginal,
      }, {
        label: 'Cancel',
        icon: 'cancel',
        action: () => {
          this.$emit('close');
          // Old way to change crop mode
          this.$emit('change-mode', null);
        },
      }];
    },
    stencilComponent() {
      return this.selectedFrameClass ?? this.standardFrame.component;
    },
    imageObject() {
      return this.parent?.currentObject;
    },
    canvasSize() {
      const wrapper = this.parent.canvas.wrapperEl.parentElement;
      return {
        h: wrapper.clientHeight * this.parent_zoom,
        w: wrapper.clientWidth * this.parent_zoom,
      };
    },
    canvasScale() {
      return this.canvasSize.w / this.parent.canvas.width;
    },
    defaultVisibleArea() {
      return {
        // translate X in image scale, consider left border instead of center
        left: -this.imageObject.left / this.imageObject.scaleX + this.imageObject.width / 2,
        top: -this.imageObject.top / this.imageObject.scaleY + this.imageObject.height / 2,
        // left: -this.imageObject.left + this.imageObject.width * (this.imageObject.scaleX / 2),
        // top: -this.imageObject.top + this.imageObject.height * (this.imageObject.scaleY / 2),
        // Whole canvas width, scaled to image
        width: this.parent.canvas.width / this.parent_zoom / this.imageObject.scaleX,
        height: this.parent.canvas.height / this.parent_zoom / this.imageObject.scaleY,
      };
    },
    /** Returns element from 'frames' array which contains currently selected Shape component */
    selectedFrame() {
      return this.frames.find((f) => f.component.name === this.stencilComponent.name) ?? this.standardFrame;
    },
  },
  watch: {
    show: {
      immediate: true,
      handler(newVal) {
        // console.log("SHOW changed to", newVal)
        if (newVal) {
          this.grabImageSrc();
          this.actionPerformed = false;
        } else {
          this.resetCropper();
        }
      },
    },
    zoom(newVal) {
      this.$nextTick().then(() => {
        this.$refs.cropper.zoom(newVal / 100);
      });
    },
  },
  methods: {
    grabImageSrc() {
      this.imageSrc = this.imageObject.getSrc();
    },
    onTap({ target }) {
      const frameClass = 'vue-preview__wrapper';
      // If tapped outside, close
      if (!target.classList.contains(frameClass)) {
        // Just close
        this.$emit('close');
        // Old way to change crop mode
        this.$emit('change-mode', null);
      }
    },
    /** Returns to original image:
     * - Sets image to original state
     * - Resets cropper stuff to work with new image state.
     *
     * Warning: This action gets "COMMITED". Change is applied even after cancelling crop */
    restoreOriginal() {
      // set imageObject to original image
      this.imageObject.setSrc(this.imageObject?.originalImageSrc ?? this.imageSrc, (newImage) => {
        //
        this.imageObject.set({
          left: this.parent.canvas.width / this.parent_zoom / 2,
          top: this.parent.canvas.height / this.parent_zoom / 2,
        });
        newImage.canvas.renderAll();
        this.resetCropper();
        this.imageSrc = newImage.getSrc();
        this.hideImageObject();
        this.key = Date.now();
        // this.$nextTick().then(() => {
        //   this.$refs.cropper.reset()
        // })
      });
    },
    resetCropper() {
      // reset frame
      this.selectedFrameClass = RectangleStencil;
      // eslint-disable-next-line
      this.showImageObject()
    },
    onContextMenuOpen() {
      this.$nextTick().then(() => {
        this.contextMenuWidth = this.$refs.contextMenu.$el.clientWidth;
      });
    },
    defaultSize(img) {
      // Should always default to the imageSize, so visibleArea should never matter.
      // Image size used is the original raw image size, ignoring canvas zoom and image's scaleX & scaleY
      const { imageSize, visibleArea } = img;
      const customRatio = this.selectedFrame.initialRatio; // undefined if frame doesn't have an "initialRatio" key

      const dLeft = Math.max(0, visibleArea.left);
      const dTop = Math.max(0, visibleArea.top);
      const dRight = Math.max(0, (-visibleArea.left + imageSize.width) - visibleArea.width);
      const dBottom = Math.max(0, (-visibleArea.top + imageSize.height) - visibleArea.height);

      const width = imageSize.width - dLeft - dRight;
      const height = imageSize.height - dTop - dBottom;

      const imageRatio = imageSize.width / imageSize.height;
      return {
        width: customRatio
          ? imageRatio < customRatio ? width : height * customRatio // Custom ratio
          : width, // Default. Use whole area
        height: customRatio
          ? imageRatio < customRatio ? width / customRatio : height // Custom ratio
          : height, // Default. Use whole area
      };
    },
    defaultPosition(img) {
      if (!this.autoCenter) {
        return {
          left: 0,
          top: 0,
        };
      }
      // Autocenter crop shape on image
      const { imageSize } = img;
      const defaultSize = this.defaultSize(img);

      return {
        left: imageSize.width / 2 - defaultSize.width / 2,
        top: imageSize.height / 2 - defaultSize.height / 2,
      };
    },
    /** Hides original image on canvas. Activates context menu */
    onCropperReady() {
      console.log('Cropper ready');
      this.$nextTick().then(() => {
        // Gets base64 representation of the source image
        // This includes all the original transformations.
        this.showImageObject();
        this.grabImageSrc();
        // eslint-disable-next-line
        this.hideImageObject()
        // eslint-disable-next-line
        this.$refs.contextMenu?.show(new Event('click'));

        // Add image overlay (the 'grayish' filter)
        // Wrap image on div, append sibling that will apply the 'filter' on css.
        // TODO: Handle cases where mask-image support is limited
        // var imagePreview = document.getElementsByClassName('vue-advanced-cropper__image')[0]
        // var wrapper = document.createElement('div')

        // imagePreview.parentNode.replaceChild(wrapper, imagePreview)
        // wrapper.appendChild(imagePreview)

        // var mask = document.createElement('div')
        // mask.classList.add('image-mask')
        // mask.style.transform = imagePreview.style.transform
        // mask.style.width = imagePreview.style.width
        // mask.style.height = imagePreview.style.height
        // mask.style.left = imagePreview.style.left
        // mask.style.top = imagePreview.style.top
        // mask.style['-webkit-mask-image'] = `url('${imagePreview.getAttribute('src')}')`
        // mask.style['-webkit-mask-size'] = 'cover'//`${imagePreview.style.width}px ${imagePreview.style.height}px`

        // imagePreview.parentNode.appendChild(mask)
      });
    },
    hideImageObject() {
      // eslint-disable-next-line
      this.imageObject?.set({
        opacity: 0,
        hasBorders: false,
        hasControls: false,
      });
      // eslint-disable-next-line
      this.parent.canvas?.renderAll();
    },
    showImageObject() {
      // eslint-disable-next-line
      this.imageObject?.set({
        opacity: 1,
        hasBorders: true,
        hasControls: true,
      });
      // eslint-disable-next-line
      this.parent.canvas?.renderAll();
    },
    onCropperChange(evt) {
      // console.log("Cropper changed", evt)
    },
    onCropperError(evt) {
      // console.log("Cropper error", evt)
    },
    doCrop() {
      this.$nextTick().then(() => {
        const cropRect = this.$refs.cropper.getResult().canvas;
        // Call processCrop. Defaul to rectangle if method not available.
        const processCrop = this.stencilComponent?.methods?.processCrop
        ?? this.stencilComponent?.extends?.methods?.processCrop
        ?? ((rect) => rect);

        const appliedStencil = processCrop(cropRect);
        this.image = appliedStencil.toDataURL();
        // this.$previewImage(this.image)
        // Finish
        this.finish();
      });
    },
    finish() {
      this.$nextTick().then(() => {
        const stencil = this.$refs.cropper.stencilCoordinates;

        const extraSettings = {
          left: stencil.left / this.canvasScale + stencil.width / 2 / this.canvasScale,
          top: stencil.top / this.canvasScale + stencil.height / 2 / this.canvasScale,

          // Original image transformations
          angle: this.imageObject.angle,
          scaleX: this.imageObject.scaleX,
          scaleY: this.imageObject.scaleY,

          opacity: 1,
          originalImageSrc: this.imageObject.originalImageSrc || this.imageSrc,
        };

        if (this.imageObject.meta) extraSettings.meta = this.imageObject.meta;
        this.parent.canvas.remove(this.imageObject);
        this.$emit('finished', { image: this.image, extra: extraSettings });
        // Old way to change crop mode
        this.$emit('change-mode', null);
      });
    },
    $previewImage(imgSrc) {
      const link = document.createElement('a');
      link.download = 'crop-preview.png';
      link.href = imgSrc;
      link.click();
      link.remove();
      // var win = window.open();
      // win.document.write(`<iframe src="${imgSrc}" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen> </iframe>`);
    },
    toKebabCase(s) {
      return s.replace(/([a-z])([A-Z])/g, '$1-$2').replace(/\s+/g, '-').toLowerCase();
    },
  },
};
</script>
<style lang="scss"
  scoped>

::v-deep .base-context-menu {
  transform: translateX(-105%);
  top: 50%;
}

// Button with shapes submenu
::v-deep .shape-submenu {
  // Submenu context menu container
  >.base-context-menu {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    padding: 12px !important;
    .menu-item__icon {
      text-align: center;
    }
  }
}

::v-deep .shape-button {
  height: 32px !important;
  width: 32px !important;
  padding: 0px !important;
  border-radius: 3px !important;
  align-items: center !important;
  justify-content: center !important;
  margin: 0 2px !important;
  &--selected {
    border: solid 1px $clementine !important;
  }
}

.wrapper {
  position: relative;
  height: 100%;
  .inner {
    border-radius: 5px;
    height: 100%;
  }

  .actions {
    position: absolute;
    top: 50%;
    left: 0;
    transform: translate(10px, -50%);
    z-index: 1062;
  }
}

.image-box-with-options {

  ::v-deep &__submenu {
    padding: 0px !important;

    .base-icon {
      margin: 0 2px !important;
      width: 32px;
      height: 32px;
      padding: 5px;
      &:hover:not(.ipad) {
        background-color: #ECE9E7 !important;
      }
    }
  }
  ::v-deep .image-box__option {
    height: 56px !important;
    .base-icon {
      border: 1px solid transparent;
    }
  }

  ::v-deep &__button > .base-icon {
    transform: scale(.7);
  }
}

.cropper {
  background: transparent;
  height: 100%;

  &-overlay {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
  }

  &__bottom-menu {
    // position: absolute;
    // bottom: -48px;
    // left: 0;
    // right: 0;
    background: $gray-light;
    height: 46px;
    border-radius: 0 0 5px 5px;
    z-index: 9999;
    display: flex;
    align-items: center;
    padding: 0 16px;
  }
}

// Border color. Only works for simple non-svg based crop stencils.
.vue- {
  &rectangle, &circle {
    ::v-deep &-stencil__preview {
      // border: 1px solid white !important;
    }
  }

  &advanced-cropper {
    ::v-deep &__background {
      opacity: 0.0;
      background-color: red;
    }
    ::v-deep &__foreground {
      opacity: 0.0;
      background-color: blue;
    }
    ::v-deep &__image {
      filter: brightness(0.3) contrast(0.7);
    }
    ::v-deep .image-mask {
      position: relative;
      background-color: rgba(0, 0, 0, 0.5);
    }
  }
}

/** Handles are just CSS squares. We want them to look like black lines with white borders.
For this, we play with css borders and pseudoelements. */

$selector-width: 5px;
$selector-length: 20px;
$selector-padding: 1px;
// Border's white background
$border-bg: $selector-width solid white;
$border-fg: calc(#{$selector-width - ( $selector-padding * 2 ) }) solid $black;

::v-deep .vue-simple-handler {
  // Handle squares. Only their appropriate borders will be visible.
  background-color: transparent;
  height: $selector-length;
  width: $selector-length;

  // common rules for all handlers (avoid copypasting like endemoniao)
  &--north, &--south, &--west, &--east {
    &:after {
      position: absolute;
      content: " ";
      border-radius: 1px;  // Lil trick ;)
    }
  }

  &--north {
    // top border
    border-top: $border-bg;
    // push selector square inwards, leave border outside
    transform: translateY(calc(50% - #{$selector-width}));
    // inner black handle
    &:after {
      width: calc(#{$selector-length} - ( #{$selector-padding} * 2 ));
      border-top: $border-fg;
      top: calc(#{$selector-padding} - #{$selector-width});
      left: $selector-padding;
    }
  }
  &--south {
    border-bottom: $border-bg;
    transform: translateY(calc(-50% + #{$selector-width}));
    &:after {
      width: calc(#{$selector-length} - ( #{$selector-padding} * 2 ));
      border-bottom: $border-fg;
      bottom: calc(#{$selector-padding} - #{$selector-width});
      left: $selector-padding;
    }
  }
  &--west {
    border-left: $border-bg;
    transform: translateX(calc(50% - #{$selector-width}));
    &:after {
      height: calc(#{$selector-length} - ( #{$selector-padding} * 2 ));
      border-left: $border-fg;
      left: calc(#{$selector-padding} - #{$selector-width});
      top: $selector-padding;
    }
  }
  &--east {
    border-right: $border-bg;
    transform: translateX(calc(-50% + #{$selector-width}));
    &:after {
      height: calc(#{$selector-length} - ( #{$selector-padding} * 2 ));
      border-right: $border-fg;
      right: calc(#{$selector-padding} - #{$selector-width});
      top: $selector-padding;
    }
  }
  &--west-north {
    transform: translate(calc(50% - #{$selector-width}), calc(50% - #{$selector-width}));
    &:after {
      top: calc(#{$selector-padding} - #{$selector-width});
    }
  }
  &--east-north {
    transform: translate(calc(-50% + #{$selector-width}), calc(50% - #{$selector-width}));
    &:after {
      top: calc(#{$selector-padding} - #{$selector-width});
    }
  }
  &--west-south {
    transform: translate(calc(50% - #{$selector-width}), calc(-50% + #{$selector-width}));
  }
  &--east-south {
    transform: translate(calc(-50% + #{$selector-width}), calc(-50% + #{$selector-width}))
  }
}

$border-width: 3px;
::v-deep .vue-simple-line {
  border-style: dotted;
  border-color: $gray;

  &--east {
    border-right-width: $border-width;
    border-left: $border-width solid transparent;
  }
  &--west {
    border-left-width: $border-width;
    border-right: $border-width solid transparent;
  }
  &--north {
    border-top-width: $border-width;
    border-bottom: $border-width solid transparent;
  }
  &--south {
    border-bottom-width: $border-width;
    border-top: $border-width solid transparent;
  }
}

// corners
// vue-simple-handler vue-simple-handler--west vue-simple-handler--south vue-simple-handler--west-south
</style>
